/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Literacy } from '../model/literacy';
import { LiteracyLookup } from '../model/literacyLookup';
import { PaginatedLiteracyList } from '../model/paginatedLiteracyList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioLiteracyService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Ordering fields: title
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioLiteracyList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedLiteracyList>;
    public childPortfolioLiteracyList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedLiteracyList>>;
    public childPortfolioLiteracyList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedLiteracyList>>;
    public childPortfolioLiteracyList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedLiteracyList>('get',`${this.basePath}/child-portfolio/literacy/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: title
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioLiteracyLookupList(ordering?: string, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<LiteracyLookup>>;
    public childPortfolioLiteracyLookupList(ordering?: string, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LiteracyLookup>>>;
    public childPortfolioLiteracyLookupList(ordering?: string, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LiteracyLookup>>>;
    public childPortfolioLiteracyLookupList(ordering?: string, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<LiteracyLookup>>('get',`${this.basePath}/child-portfolio/literacy/lookup/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: title
     * @param id A UUID string identifying this Gramotnost.
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioLiteracyRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<Literacy>;
    public childPortfolioLiteracyRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Literacy>>;
    public childPortfolioLiteracyRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Literacy>>;
    public childPortfolioLiteracyRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioLiteracyRetrieve.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Literacy>('get',`${this.basePath}/child-portfolio/literacy/${encodeURIComponent(String(id))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
